import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-bar-current-travelers',
  templateUrl: './nav-bar-current-travelers.component.html',
  styleUrls: ['./nav-bar-current-travelers.component.css']
})
export class NavBarCurrentTravelersComponent implements OnInit {
  public isCollapsed = false;
  constructor() {}

  ngOnInit() {}
}
